import { createRouter, createWebHistory } from "vue-router";
import Home from "../view/Home.vue";
import Services from "../view/Services.vue";
import Requests from "../view/Requests.vue";
import NewService from "../view/NewService.vue";
import EditService from "../view/EditService.vue";
import Service from "../view/Service.vue";
import ServicesService from "@/service/ServicesService";
import AxiosAdapter from "@/infra/AxiosAdapter";
import RequestsService from "@/service/RequestsService";
import Logs from "../view/Logs.vue";
import Log from "../view/Log.vue";

export default class RouterBuilder {
	routes: any[];

	constructor (readonly baseUrl: string) {
		this.routes = [
			{ path: '/', component: Home },
			{ path: '/services', component: Services, props: { servicesService: new ServicesService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/new', component: NewService, props: { servicesService: new ServicesService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService/edit', component: EditService, props: { servicesService: new ServicesService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService', component: Service, props: { servicesService: new ServicesService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService/requests', component: Requests, props: { requestsService: new RequestsService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService/requests/:idRequest/logs', component: Logs, props: { requestsService: new RequestsService(new AxiosAdapter(), baseUrl) } },
			{ path: '/services/:idService/requests/:idRequest/logs/:idRequestLog', component: Log, props: { requestsService: new RequestsService(new AxiosAdapter(), baseUrl) } }
		];
	}

	build () {
		const router = createRouter({
			history: createWebHistory('/admin/'),
			routes: this.routes,
		});
		return router;
	}
}
